import { createApp } from 'vue'
import App from './App.vue'
import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from './quasar-user-options'
import router from './router/router'
import store from "./store"
import { Format } from './composables/format'

const {format}  = Format() 
const app = createApp(App)
app.directive('money',{
    mounted(el){
        el.addEventListener('input',formatMoney)
    }
})

function formatMoney(e){
    const s = store.getters.getAll
   const money = format(e.target.value, true)
    e.target.value = money;
    store.commit('setAll',{...s,[e.target.name]:money})
}
app.use(store).use(Quasar, quasarUserOptions).use(router).mount('#app')
